import { CpRefundsRequestInterface } from '../../../interfaces/request/refunds/cp-refunds-request-interface';

export class CpRefundsRequestModel implements CpRefundsRequestInterface {
  Cards: string = '';
  EndDate: string = '';
  Page: number = 1;
  PageSize: number = 5;
  StartDate: string = '';
  Type: string = '';

  constructor(init?: Partial<CpRefundsRequestModel>) {
    Object.assign(this, init);
  }
}
